import React from "react";
import styled from "@emotion/styled";
import { SvgIcon, SvgNames } from "../../assets/icons/SvgIcon";
import {
  ERROR_20,
  ERROR_70,
  ERROR_90,
  INFO_20,
  INFO_70,
  INFO_90,
  SUCCESS_20,
  SUCCESS_70,
  SUCCESS_90,
  WARNING_20,
  WARNING_70,
  WARNING_90,
} from "../../design-tokens";
import { Typography } from "../Typography/Typography";

const pillIconType = {
  success: SvgNames.SuccessOutline,
  error: SvgNames.Warning,
  warning: SvgNames.WarningOutline,
  info: SvgNames.InfoOutline,
};

const pillTextColor = {
  success: SUCCESS_20,
  error: ERROR_20,
  warning: WARNING_20,
  info: INFO_20,
};

const pillBackgroundColor = {
  success: SUCCESS_90,
  error: ERROR_90,
  warning: WARNING_90,
  info: INFO_90,
};

const pillBorderColor = {
  success: SUCCESS_70,
  error: ERROR_70,
  warning: WARNING_70,
  info: INFO_70,
};

const Pill = ({
  text,
  type = "success",
  icon,
  className,
  hideIcon,
}: PillProps) => {
  return (
    <PillContainer
      data-testid="pill-container"
      className={className}
      backgroundColor={pillBackgroundColor[type]}
      borderColor={pillBorderColor[type]}
    >
      {!hideIcon && (
        <IconContainer>
          <SvgIcon
            data-testid="pill-icon"
            color={pillTextColor[type]}
            width={16}
            height={16}
            name={icon || pillIconType[type]}
          />
        </IconContainer>
      )}
      <TypographyStyled color={pillTextColor[type]}>{text}</TypographyStyled>
    </PillContainer>
  );
};

type PillProps = {
  text: string;
  type?: PillType;
  icon?: SvgNames;
  hideIcon?: boolean;
  className?: string;
};

type PillType = "error" | "success" | "warning" | "info";

const PillContainer = styled.div<{
  borderColor: string;
  backgroundColor: string;
}>`
  display: flex;
  padding: 7px 32px;
  width: fit-content;
  justify-content: center;
  align-items: center;
  gap: 4px;
  white-space: pre;
  min-height: 30px;
  box-sizing: border-box;
  border-radius: 6px;
  border: 1px solid ${(props) => props.borderColor};
  background: ${(props) => props.backgroundColor};
`;

const TypographyStyled = styled(Typography)`
  font-size: 12px;
  text-align: center;
`;

const IconContainer = styled.div`
  height: 16px;
`;

export type { PillProps };
export { Pill };
